<template>
  <footer
    id="footer"
    class="mx3-footer footer dark-background"
  >
    <div class="footer-main">
      <div class="container">
        <div class="row gy-5">
          <div class="col-lg-4 col-md-12 text-center text-lg-start">
            <div class="footer-widget footer-about">
              <span href="/" class="logo d-flex justify-content-center justify-content-lg-start">
                <mx3-logo force-dark />
              </span>
              <p class="mt-3 description">
                Somos especialistas em soluções de redes e conectividade.
                Oferecemos uma ampla gama de roteadores, switches, access points
                e acessórios para atender todas as suas necessidades de rede.
              </p>

              <div class="social-links-container mt-4">
                <h5>Siga-nos nas Redes</h5>
                <div class="social-links d-flex justify-content-center justify-content-lg-start gap-3">
                  <a href="#" class="social-link facebook" title="Facebook"><i class="bi bi-facebook"></i></a>
                  <a href="#" class="social-link instagram" title="Instagram"><i class="bi bi-instagram"></i></a>
                  <a href="#" class="social-link twitter" title="Twitter"><i class="bi bi-twitter-x"></i></a>
                  <a href="#" class="social-link linkedin" title="LinkedIn"><i class="bi bi-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 col-lg-2">
            <div class="footer-widget">
              <h4>Produtos</h4>
              <ul class="footer-links">
                <li><a href="/">Roteadores</a></li>
                <li><a href="/">Switches</a></li>
                <li><a href="/">Access Points</a></li>
                <li><a href="/">Cabos de Rede</a></li>
                <li><a href="/">Acessórios</a></li>
                <li><a href="/">Promoções</a></li>
              </ul>
            </div>
          </div>

          <div class="col-6 col-lg-2">
            <div class="footer-widget">
              <h4>Suporte</h4>
              <ul class="footer-links">
                <li><a href="/contato">Central de Ajuda</a></li>
                <li><a href="/contato">Status do Pedido</a></li>
                <li><a href="/contato">Informações de Envio</a></li>
                <li><a href="/contato">Política de Trocas</a></li>
                <li><a href="/contato">Guia de Instalação</a></li>
                <li><a href="/contato">Fale Conosco</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-12">
            <div class="footer-widget">
              <h4>Informações de Contato</h4>
              <div class="footer-contact">
                <div class="contact-item">
                  <i class="bi bi-geo-alt"></i>
                  <span>R. Empresário João Rodrigues Alves, n° 125 (302b e 604b) - Bancários, João Pessoa - PB, 58051-022</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-telephone"></i>
                  <span>(83) 9 9149-3136</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-envelope"></i>
                  <span>contato@mx3network.com</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-clock"></i>
                  <span>Segunda-Sexta: 8h-18h<br />Sábado: 9h-13h<br />Domingo: Fechado</span>
                </div>
              </div>

              <div class="app-buttons mt-4 d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start">
                <a href="#" class="app-btn" id="btnInstall">
                  <i class="bi bi-apple"></i>
                  <span>App Store</span>
                </a>
                <a href="#" class="app-btn" id="btnInstall2">
                  <i class="bi bi-google-play text-success"></i>
                  <span>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="row gy-3 align-items-center">
          <div class="col-lg-6 col-md-12 text-center text-lg-start order-2 order-lg-1">
            <div class="copyright">
              <p>© <span>Copyright</span> <strong class="sitename text-primary">MX3 Network</strong>. Todos os direitos reservados.</p>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 order-1 order-lg-2">
            <div class="d-flex flex-wrap justify-content-center justify-content-lg-end align-items-center gap-4">
              <div class="payment-methods">
                <div class="payment-icons d-flex gap-2">
                  <img src="/assets/img/logos/visa.png" alt="visa" class="pay-img" />
                  <img src="/assets/img/logos/master.png" alt="master" class="pay-img" />
                  <img src="/assets/img/logos/itau.png" alt="itau" class="pay-img" />
                  <img src="/assets/img/logos/pix.png" alt="pix" class="pay-img pix" />
                  <img src="/assets/img/logos/boleto.png" alt="boleto" class="pay-img" />
                </div>
              </div>

              <div class="legal-links">
                <a href="/termos" @click.prevent="$router.push('/termos')">Termos</a>
                <a href="/privacidade" @click.prevent="$router.push('/privacidade')">Privacidade</a>
                <a href="/cookies" @click.prevent="$router.push('/cookies')">Cookies</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import templateMixin from "../mixins/templateMixin";

export default {
  name: "Footer",
  mixins: [templateMixin],
  data() {
    return {
      deferredPrompt: null,
    };
  },
  mounted() {
    this.initScrollTop();
    this.initInstallLogic("btnInstall");
    this.initInstallLogic("btnInstall2");
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
  },
  methods: {
    initInstallLogic(id) {
      const btn = document.getElementById(id);
      if (btn) {
        btn.addEventListener("click", async () => {
          if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            await this.deferredPrompt.userChoice;
            this.deferredPrompt = null;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mx3-footer {
  backdrop-filter: blur(10px);
  background: #0a0e1acc !important;
  font-family: sans-serif; /* Ajuste para a fonte padrão do seu projeto */

  .footer-main {
    padding: 60px 0 30px;
    @media (max-width: 768px) { padding: 40px 0 20px; }
  }

  .description {
    color: var(--mx3-style-text-muted, #9ca3af);
    font-size: 0.95rem;
    line-height: 1.6;
  }

  h4, h5 {
    color: #fff;
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 20px;
    @media (max-width: 768px) { font-size: 1rem; margin-bottom: 15px; }
  }

  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 10px;
      a {
        color: var(--mx3-style-text-muted, #9ca3af);
        text-decoration: none;
        transition: 0.3s;
        font-size: 0.9rem;
        &:hover { color: var(--mx3-style-primary, #00d9ff); }
      }
    }
  }

  .footer-contact {
    .contact-item {
      display: flex;
      gap: 12px;
      margin-bottom: 15px;
      color: var(--mx3-style-text-muted, #9ca3af);
      font-size: 0.9rem;
      i { color: var(--mx3-style-primary, #00d9ff); font-size: 1.1rem; }
    }
  }

  .social-link {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: white;
    font-size: 1.2rem;
    transition: all 0.3s ease;
    
    &:hover { transform: translateY(-5px); }
    &.facebook { background: #1877F2; }
    &.instagram { background: linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4); }
    &.twitter { background: #000; }
    &.linkedin { background: #0A66C2; }
  }

  .app-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: white;
    text-decoration: none;
    font-size: 0.85rem;
    i { font-size: 1.3rem; }
    &:hover { background: rgba(255, 255, 255, 0.1); }
  }

  .footer-bottom {
    padding: 25px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    
    .pay-img {
      height: 25px;
      background: white;
      padding: 2px 4px;
      border-radius: 4px;
      object-fit: contain;
      &.pix { width: 35px; }
    }

    .legal-links a {
      color: var(--mx3-style-text-muted, #9ca3af);
      font-size: 0.85rem;
      text-decoration: none;
      &:hover { color: var(--mx3-style-primary, #00d9ff); }
    }

    .copyright p {
      margin: 0;
      font-size: 0.85rem;
      color: var(--mx3-style-text-muted, #9ca3af);
    }
  }
}
</style>